import { render } from "./DashboardTabTotalsMobile.vue?vue&type=template&id=4cfa20b6&scoped=true&ts=true"
import script from "./DashboardTabTotalsMobile.vue?vue&type=script&lang=ts"
export * from "./DashboardTabTotalsMobile.vue?vue&type=script&lang=ts"

import "./DashboardTabTotalsMobile.vue?vue&type=style&index=0&id=4cfa20b6&lang=scss&scoped=true"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cfa20b6"]])

export default __exports__